



















































































































import {
  faTimes,
  faUpload,
  faImage,
  faFileAlt
} from '@fortawesome/free-solid-svg-icons'
import CFileUploadMixin from '~/components/shared/configurable/mixin/CFileUploadMixin.vue'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'

export default defineComponent({
  components: { CCustomSelect },
  mixins: [CFileUploadMixin],
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    attachmentType: {
      type: String,
      required: false,
      default: 'resume'
    },
    showExtensions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      icons: {
        upload: faUpload,
        times: faTimes,
        image: faImage,
        file: faFileAlt
      },
      dropOver: false,
      fetched: false,
      fetchedAttachments: [],
      selectedValue: null
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    fetchedAttachmentsOptions() {
      if (this.fetchedAttachments.length) {
        return this.fetchedAttachments.map(a => {
          return {
            name: a.name,
            value: a.file,
            type: a.content_type
          }
        })
      }

      return []
    }
  },
  watch: {
    uploading(val) {
      this.$emit('upload-change', val)
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$axios
        .get('/api/account/messages/attachments/', {
          params: { tag: this.attachmentType }
        })
        .then(response => {
          this.fetchedAttachments = response.data.data.attachments

          this.fetched = true
        })
        .catch(() => {
          this.fetched = true
        })
    },
    emitForm() {
      if (this.files[0]) {
        this.$emit('change', [this.files[0].attachmentData])
      } else {
        this.$emit('change', [])
      }
    },
    triggerInput() {
      const input = this.$refs['attachment-input']
      input.value = null
      input.click()
    },
    fileNotAnImage(origFile, currentFilesLength) {
      if (origFile.file.type.match('application/pdf')) {
        origFile.thumb = require('~/assets/img/icons/icon_pdf.png')
        origFile.type = 'pdf'
        this.realAddFile(origFile, currentFilesLength)
      } else {
        alert(this.$t('this file type is not supported'))
      }
    },
    realAddFile(origFile) {
      // to only have one file and not worry about queue uploading:
      this.files[0] = origFile
      this.postFile(this.files[0])
    },
    removeFile() {
      this.files = []
      this.selectedValue = null
      this.emitForm()
    },
    onPostSuccess(response, theFile) {
      if (response.data.data) {
        theFile.approved = true
        theFile.attachmentData = response.data.data
        theFile.filename = response.data.data.name
        this.emitForm()
      }
    },
    selectChange(fileSelected) {
      this.files[0] = {}
      this.files[0].attachmentData = this.fetchedAttachments.filter(m => {
        return m.file === fileSelected
      })[0]

      if (this.files[0].attachmentData.content_type === 'application/pdf') {
        this.files[0].thumb = require('~/assets/img/icons/icon_pdf.png')
        this.files[0].type = 'pdf'
      } else {
        this.files[0].thumb =
          this.files[0].attachmentData.domain +
          this.files[0].attachmentData.file
        this.files[0].type = 'image'
      }

      this.files[0].filename = this.files[0].attachmentData.name
      this.files[0].approved = true

      this.emitForm()
    },
    onDragover(e) {
      e.preventDefault()
      e.stopPropagation()
      this.dropOver = true
    },
    onDragleave(e) {
      e.preventDefault()
      e.stopPropagation()
      this.dropOver = false
    },
    onDrop(e) {
      e.preventDefault()
      e.stopPropagation()
      this.dropOver = false
      this.addFiles(e)
    }
  }
})
